export default API => ({
    // 根据测评报告ID查询测评报告详情
    reportFindById({params}){
        return API({
            url: '/assess/v1/open/assessReport/findById',
            params,
        })
    },
    // 根据评测结果ID查询测评报告详情
    findByResultIdId({params}) {
        return API({
            url: '/assess/v1/open/assessUserResult/findByResultIdId',
            params,
        })
    },
    // 学生测评报告列表
    reportList({data,params}) {
        return API({
            url: '/assess/v1/open/assessReport/list',
            method: 'post',
            params,
            data,
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    // 学生测评详情
    findByIdAndRef({data, params}) {
        return API({
            url: '/assess/v1/open/assess/findByIdAndRef',
            method: 'post',
            params,
            data
        })
    },
    // 评测的试题列表
    reportQuestionList({data, params}){
        return API({
            url: '/assess/v1/open/assessUserAnswer/questionList',
            method: 'post',
            params,
            data,
        })
    },
    // 交卷
    reportSaveUserAnswer({data}){
        return API({
            url: '/assess/v1/open/assessUserAnswer/saveUserAnswer',
            method: 'post',
            data,
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    // 学生测评结果列表
    reportHistoryList({data, params}){
        return API({
            url: '/assess/v1/open/assessUserResult/list',
            method: 'post',
            data,
            params
        })
    },
    /**
     *@description:
     *@modifyContent:测评接口地址更改
     *@date: 2021-06-10 17:28:36
    */
    getAssessUrl({data, params}) {
        return API({ url: '/assess/v1/open/assess/getJiaZhengAssessUrl', params, data });
    }, 
    getmiaoFindUserBranchList({data, params}) {
        return API({
            url: '/usercenter/v1/miaoshenaccount/findUserBranchList' ,
            data,
            params
        });
    },
})